import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "5fa2d783-f7a2-447a-9eab-291c993164d9", content: "c", options: {} },
  { id: "dac60dda-2245-492a-9f2a-a5eaf97b0281", content: "b", options: {} },
  { id: "7f2be40f-0cad-4211-8767-612879115d70", content: "d", options: {} },
  { id: "70c94837-9795-4143-a1c6-f8632392ab77", content: "a", options: {} },
];

const groups = [
  { id: "00797f15-0651-427f-9c99-a74fa4f1b197", content: "", options: {} },
  { id: "9af6854a-ed9b-4506-8f30-83a094e296e4", content: "", options: {} },
  { id: "8796ccc1-8369-4abe-9591-fff782a45b0a", content: "", options: {} },
  { id: "2c7036ad-9e91-4695-86e1-c34e5cfc7cc2", content: "", options: {} },
];

export const task: Task = {
  id: "ec2c782b-ceb5-4367-9015-bcd98cf76919",
  solutionType: "order",
  type: "orderLabels",
  options: {
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "order",
  data: [
    "5fa2d783-f7a2-447a-9eab-291c993164d9",
    "dac60dda-2245-492a-9f2a-a5eaf97b0281",
    "7f2be40f-0cad-4211-8767-612879115d70",
    "70c94837-9795-4143-a1c6-f8632392ab77",
  ],
};
